import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"down\">\n  <path d=\"M45.256 64.985c.81-.05 1.579-.37 2.186-.909l36.343-32.708a3.65 3.65 0 1 0-4.884-5.423L45 56.467 11.099 25.945a3.648 3.648 0 1 0-4.884 5.423l36.343 32.708a3.637 3.637 0 0 0 2.698.909Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol